var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ul', {
    staticClass: "tab_writing"
  }, [_vm._l(_vm.links, function (item, i) {
    var _vm$$route$query;

    return [_c('li', {
      key: i,
      class: ((_vm$$route$query = _vm.$route.query) === null || _vm$$route$query === void 0 ? void 0 : _vm$$route$query.tabIndex) == item.tabIndex ? 'on' : null
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0);"
      },
      on: {
        "click": function ($event) {
          return _vm.changePage(item);
        }
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")])])];
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }